import type { ExtraFieldTypeTextLabel } from "@package/ui-gql/index-data-access";
import { useMemo } from "react";
import { isConditionFalsey } from "../service-data-form-utils";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldTextLabelProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeTextLabel;
};

function ServiceDataFormFieldTextLabelContent({
  data,
  field,
}: ServiceDataFormFieldTextLabelProps) {
  const disabled = useMemo<boolean>(
    () => !!field.condition && isConditionFalsey(field.condition, data),
    [data, field.condition],
  );

  if (disabled) {
    return null;
  }

  return <h6 className="bp6-heading">{field.initialValue}</h6>;
}

export function ServiceDataFormFieldTextLabel({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeTextLabel") {
    return (
      <ServiceDataFormFieldTextLabelContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
